export const SummaryMetricsChartsSelectors = [
  'chartSales',
  'chartNewCustomerSales',
  'netSalesChart',
  'chartReturningCustomerSales',
  'totalPaymentGatewayCostsChart',
  'chartShopifyAov',
  'chartShopifyAovIncludeZero',
  'chartShopifyCpa',
  'chartGaRevenuePerTransaction',
  'chartFacebookInsights',
  'chartGoogleAds',
  'googleAdsClicksChart',
  'googleConversionValueChart',
  'chartSnapchatAds',
  'snapchatRoasChart',
  'snapchat_impressions_chart',
  'snapchat_swipes_chart',
  'snapchatCpmChart',
  'snapchatCpaChart',
  'chartSnapchatConversionPurchasesValue',
  'chartSnapchatConversionPurchases',
  'chartGaTransactionsPerSession',
  'chartGaUsers',
  'chartOrders',
  'chartOrdersWithAmount',
  'chartNewGrossSales',
  'chartTotalCpa',
  'chartRefunds',
  'chartFacebookPurchaseRoas',
  'googleAdsRoasChart',
  'googleAdsConversionsChart',
  'googleCpaChart',
  'totalGoogleAdsCpmChart',
  'googleCpcChart',
  'totalGoogleAdsImpressionsChart',
  'totalCustomSpendsChart',
  'merChart',
  'totalReturnsChart',
  'totalRevenuePerSessionChart',
  'googleAllConversionValueChart',
  'totalAllRoasChart',
  'googleAdsAllConversionsChart',
  'googleAllCpaChart',
  'totalGoogleAdsCtrChart',
  'chartFacebookCpc',
  'chartFacebookCpm',
  'facebookViewThroughChart',
  'facebookViewThroughRoasChart',
  'facebookViewThroughCpaChart',
  'chartFacebookCtr',
  'chartFacebookCostPerOutboundClick',
  'facebookConversionValueChart',
  'facebookRevenuePerClickChart',
  'facebookCpaChart',
  'facebookPurchasesChart',
  'facebookMetaPurchasesChart',
  'facebookWebPurchasesChart',
  'facebookWebConversionValueChart',
  'facebookMetaConversionValueChart',
  'chartNewCustomersCpa',
  'chartKlaviyoPlacedOrderSalesPercent',
  'chartKlaviyoPlacedOrderSalesPercentFlows',
  'chartKlaviyoPlacedOrderSalesPercentCampaigns',
  'chartKlaviyoUnsubscribed',
  'chartKlaviyoPlacedOrderTotalPriceFlows',
  'chartKlaviyoPlacedOrderTotalPriceFlows',
  'chartKlaviyoPlacedOrderTotalPriceCampaigns',
  'chartKlaviyoPlacedOrderTotalPriceCampaigns',
  'chartKlaviyoSubscribedToList',
  'chartKlaviyoClickedEmail',
  'chartKlaviyoReceivedEmail',
  'chartKlaviyoClickedSms',
  'chartKlaviyoCVR',
  'chartKlaviyoRevenuePerEmail',
  'chartKlaviyoNetNewSubscribers',
  'tiktokSpendChart',
  'tiktokRoasChart',
  'tiktokImpressionsChart',
  'chartTiktokCpm',
  'chartTiktokCpc',
  'chartTiktokCtr',
  'tiktokCpaChart',
  'tiktokConversionValueChart',
  'tiktokPurchases',
  'tiktokPurchasesChart',
  'twitterSpendChart',
  'twitterRoasChart',
  'twitterImpressionsChart',
  'twitterClicksChart',
  'twitterConversionValueChart',
  'twitterPurchasesChart',
  'twitterEngagementsChart',
  'twitterFollowsChart',
  'twitterCpmChart',
  'twitterCpaChart',
  'bingAdSpend',
  'bingConversions',
  'bingConversionValue',
  'bingClicks',
  'bingImpressions',
  'bingRoas',
  'bingCtr',
  'bingCpa',
  'bingCpm',
  'bingAdSpendChart',
  'bingConversionsChart',
  'bingConversionValueChart',
  'bingClicksChart',
  'bingImpressionsChart',
  'bingRoasChart',
  'bingCtrChart',
  'bingCpaChart',
  'bingCpmChart',
  'chartOrders',
  'chartTaxes',
  'chartNetTaxes',
  'chartCogs',
  'chartTotalVariantsSold',
  'chartHandlingFees',
  'chartNewCustomersPercent',
  'chartOldCustomersPercent',
  'chartNewCustomersOrders',
  'totalShippingCostsChart',
  'totalDiscountsChart',
  'chartGaUsers',
  'chartGorgiasTicketsCreated',
  'chartGorgiasTicketsReplied',
  'chartGorgiasResponseTime',
  'chartGorgiasResolutionTime',
  'chartGorgiasResolutionTime',
  'chartBlendedAds',
  'chartRoas',
  'totalNetProfitChart',
  'chartNewCustomerRoas',
  'chartBlendedAttributedRoas',
  'chartBlendedAttributedRoas',
  'pinterestSpendChart',
  'pinterestRoasChart',
  'pinterestCpcChart',
  'pinterestCpmChart',
  'pinterestConversionValueChart',
  'pinterestPurchasesChart',
  'pinterestImpressionsChart',
  'pinterestCtrChart',
  'chartPixelUsers',
  'chartPixelOrders',
  'chartPixelSales',
  'chartPixelAddToCarts',
  'pixelAvgPagesPerSessionChart',
  'pixelAvgSessionDurationChart',
  'pixelBounceRateChart',
  'pixelNewVisitorsChart',
  'pixelPercentNewVisitorsChart',
  'orderTagsCharts',
  'sourcesCharts',
  'customMetricsCharts',
  'willyChart',
  'externalAppsChart',
  'chartBenchmarksCPM',
  'chartBenchmarksCPC',
  'chartBenchmarksCTR',
  'chartBenchmarksNCROAS',
  'chartBenchmarksNCPA',
  'chartBenchmarksBlendedROAS',
  'chartBenchmarksTotalSpendAAvg',
  'chartBenchmarksFBAdsNewCustomersAvg',
  'chartBenchmarksSize',
  'chartBenchmarksOrdersAvg',
  'chartBenchmarksNewCustomersTotalPriceAvg',
  'chartBenchmarksTotalPriceUSDAvg',
  'chartBenchmarksFBAdsSpendAvg',
  'chartBenchmarksFBAdsImpressionsAvg',
  'chartBenchmarksFBAdsClicksAvg',
  'chartBenchmarksFacebookRoas',
  'chartBenchmarksGoogleRoas',
  'chartBenchmarksCPCGoogle',
  'chartBenchmarksCPMGoogle',
  'chartBenchmarksCTRGoogle',
  'chartBenchmarksGoogleAdsSpendAvg',
  'chartBenchmarksCTRTiktok',
  'chartBenchmarksCPCTiktok',
  'chartBenchmarksTiktokRoas',
  'chartBenchmarksTiktokAdsSpendAvg',
  'chartBenchmarksBlendedCTR',
  'chartBenchmarksBlendedCpc',
  'chartAttentiveNewSubscribed',
  'chartAttentiveNetNewsubscribers',
  'chartAttentiveUnsubscribed',
  'chartAttentivePlacedOrderSalesPercent',
  'chartAttentivePlacedOrderTotalPriceFlows',
  'chartAttentivePlacedOrderTotalPriceFlows',
  'chartAttentivePlacedOrderTotalPriceCampaigns',
  'chartAttentivePlacedOrderTotalPriceCampaigns',
  'chartFacebookLikes',
  'chartFacebookComments',
  'chartFacebookShares',
  'chartFacebookPosts',
  'chartFacebookFollowers',
  'chartFacebookImpressions',
  'chartFacebookSocialAvg',
  'chartFacebookReach',
  'chartFacebookProfileView',
  'chartFacebookWebsiteClicks',
  'chartInstagramLikes',
  'chartInstagramComments',
  'chartInstagramShares',
  'chartInstagramPosts',
  'chartInstagramFollowers',
  'chartInstagramImpressions',
  'chartInstagramAvg',
  'chartInstagramAvgImpressionsFollowers',
  'chartInstagramReach',
  'chartInstagramProfileView',
  'chartInstagramWebsiteClicks',
  'influencerConversionValueChart',
  'influencerSpendChart',
  'influencerRoasChart',
  'influencerPurchasesChart',
  'influencerNcPurchasesChart',
  'influencerNcConversionValueChart',
  'totalCustomAdSpendsChart',
  'totalCustomNonAdSpendsChart',
  'chartBlendedSales',

  // amazon
  'chartAmazonSales',
  'chartAmazonProductItemPrice',
  'chartAmazonSalesTaxes',
  'chartAmazonOrders',
  'chartAmazonItems',
  'chartAmazonFees',
  'chartAmazonSalesAFN',
  'chartAmazonProductItemPriceAFN',
  'chartAmazonSalesTaxesAFN',
  'chartAmazonOrdersAFN',
  'chartAmazonItemsAFN',
  'chartAmazonFeesAFN',
  'chartAmazonSalesMFN',
  'chartAmazonProductItemPriceMFN',
  'chartAmazonSalesTaxesMFN',
  'chartAmazonOrdersMFN',
  'chartAmazonItemsMFN',
  'chartAmazonFeesMFN',

  'chartCanceledAmazonSales',
  'chartCanceledAmazonProductItemPrice',
  'chartCanceledAmazonSalesTaxes',
  'chartCanceledAmazonOrders',
  'chartCanceledAmazonItems',
  'chartCanceledAmazonFees',
  'chartCanceledAmazonSalesAFN',
  'chartCanceledAmazonProductItemPriceAFN',
  'chartCanceledAmazonSalesTaxesAFN',
  'chartCanceledAmazonOrdersAFN',
  'chartCanceledAmazonItemsAFN',
  'chartCanceledAmazonFeesAFN',
  'chartCanceledAmazonSalesMFN',
  'chartCanceledAmazonProductItemPriceMFN',
  'chartCanceledAmazonSalesTaxesMFN',
  'chartCanceledAmazonOrdersMFN',
  'chartCanceledAmazonItemsMFN',
  'chartCanceledAmazonFeesMFN',

  'chartAmazonAds',
  'chartAmazonClicks',
  'amazonRoasChart',
  'chartAmazonPurchases',
  'chartAmazonCPC',
  'amazonConversionValueChart',

  'chartAmazonNetSales',
  'cahrtAmazonNetProfit',
  'amazonMERChart',
  'amazonAOVChart',
  'amazonCPAChart',
  'amazonExpensesChart',

  //kno
  'totalFacebookKnoChart',
  'totalGoogleKnoChart',
  'totalSnapchatKnoChart',
  'totalTiktokKnoChart',
  'totalPinterestKnoChart',
  'totalInstagramKnoChart',

  //fairing
  'responsesPrecentChart',
  'totalFacebookEnqChart',
  'totalGoogleEnqChart',
  'totalSnapchatEnqChart',
  'totalTiktokEnqChart',
  'totalPinterestEnqChart',
  'totalInstagramEnqChart',

  // pixel
  'pixelUniqueVisitorsChart',
  'pixelVisitorsChart',
  'pixelUniqueAtcChart',
  'pixelUniqueSessionsAtcChart',
  'pixelPurchasesChart',
  'pixelConversionRateChart',
  'pixelPercentAtcChart',
  'pixelCostPerSessionChart',
  'pixelCostPerAtcChart',

  // recharge

  'rechargeSubscription1stOrderSalesChart',
  'rechargeSubscriptionRecurringOrderChart',
  'rechargeTotalSubscriptionSalesChart',
  'rechargeSubscriptionSalesPercentageChart',
  'rechargeTotalNewSubscriptionsChart',
  'rechargeTotalCancelledSubscriptionsChart',
  'rechargeTotalChurnedSubscribersChart',
  'rechargeTotalActiveSubscriptionsChart',
  'rechargeTotalActiveSubscribersChart',
  'rechargeAverageActiveDaysChart',
  'rechargeAverageSubscriptionsPerCustomerChart',
  'rechargeReactivatedSubscribersChart',

  // stripe

  'stripeSubscriptionUpgradeCountChart',
  'stripeSubscriptionUpgradeAmountChart',
  'stripeSubscriptionDowngradeCountChart',
  'stripeSubscriptionDowngradeAmountChart',
  'stripeSubscriptionDeletedCountChart',
  'stripeSubscriptionDeletedAmountChart',

  //MNTN
  'mountainSpendChart',
  'mountainRoasChart',
  'mountainImpressionsChart',
  'mountainConversionsChart',
  'mountainConversionRateChart',
  'mountainAverageOrderValueChart',
  'mountainCostPerAcquisitionChart',
  'mountainCostPerVisitChart',
  'mountainConversionValueChart',

  //criteo
  'criteoSpendChart',
  'criteoRoasChart',
  'criteoDisplaysChart',
  'criteoConversionsChart',
  'criteoConversionRateChart',
  'criteoAverageOrderValueChart',
  'criteoVisitsChart',
  'criteoClicksChart',
  'criteoCostPerAcquisitionChart',
  'criteoCostPerVisitChart',
  'criteoConversionValueChart',

  // shipstation
  'shipstationCost',
  'shipstationCostChart',
  'shipstationShipments',
  'shipstationShipmentsChart',
  'shipstationOrders',
  'shipstationOrdersChart',
  'shipstationOrdersShipped',
  'shipstationOrdersShippedChart',
  'shipstationOrdersUnshipped',
  'shipstationOrdersUnshippedChart',
  'shipstationAvgCostPerShipment',
  'shipstationAvgCostPerShipmentChart',
  'shipstationEstimation',
  'shipstationEstimationChart',

  //smsbump
  'smsbumpRevenueChart',
  'smsbumpCampaignRevenueChart',
  'smsbumpFlowRevenueChart',
  'smsbumpSpendChart',
  'smsbumpSentChart',
  'smsbumpUnsubscribedChart',
  'smsbumpConversionsChart',
  'smsbumpAovChart',
  'smsbumpCtrChart',
  'smsbumpRoasChart',
  'smsbumpRoiChart',
  'smsbumpDeliveredChart',
  'smsbumpClicksChart',

  // shipbob
  'shipbobOrders',
  'shipbobOrdersChart',
  'shipbobOrdersFulfilled',
  'shipbobOrdersFulfilledChart',
  'shipbobPercentOfOrdersFulfilledOnTime',
  'shipbobPercentOfOrdersFulfilledOnTimeChart',
  'shipbobFulfillmentCost',
  'shipbobFulfillmentCostChart',
  'shipbobAvgFulfillmentCost',
  'shipbobAvgFulfillmentCostChart',
  'shipbobEstimation',
  'shipbobEstimationChart',

  //postscript
  'postscriptRevenueChart',
  'postscriptSentChart',
  'postscriptSubscribedChart',
  'postscriptUnsubscribedChart',
  'postscriptConversionsChart',
  'postscriptDeliveredChart',
  'postscriptAovChart',
  'postscriptCtrChart',
  'postscriptClicksChart',
] as const;
